export type Rng = () => number;

/**
 * One step of mulberry32. Game state stores the raw 32-bit accumulator so the
 * RNG survives JSON round-trips (Durable Object storage, snapshots).
 */
export function rngNext(state: number): [value: number, next: number] {
  const a = (state + 0x6d2b79f5) >>> 0;
  let t = a;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return [((t ^ (t >>> 14)) >>> 0) / 4294967296, a];
}

export function mulberry32(seed: number): Rng {
  let s = seed >>> 0;
  return () => {
    const [value, next] = rngNext(s);
    s = next;
    return value;
  };
}

export function randomInt(rng: Rng, maxExclusive: number): number {
  return Math.floor(rng() * maxExclusive);
}

export function shuffle<T>(rng: Rng, items: readonly T[]): T[] {
  const out = items.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = randomInt(rng, i + 1);
    [out[i], out[j]] = [out[j]!, out[i]!];
  }
  return out;
}
